"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { DarkModeToggle } from "../../Components";
import HeaderNav from "../../Components/HeaderNav";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderSectionSupport3sItem = {
    key: Key | null | undefined;
    /** Detected variants: "support-item mb-3" | "support-item" */
    className: string;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    i0ClassName: string;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    h50Text: ReactNode;
    /** Detected variants: "General Inquiries" | "Emergency Cases" */
    p0Text: ReactNode;
    /** Detected variants: "avatar avatar-lg bg-primary rounded-circle" */
    div0ClassName?: string;
    /** Detected variants: "link" */
    h50ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
};

type HeaderSectionPercentsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/banner/banner-percent-1.jpg" | "/Templates/Doccure/img/banner/banner-percent-2.jpg" */
    src: string;
    /** Detected variants: "40%" | "80%" */
    h50Text: ReactNode;
    /** Detected variants: "Body" | "Face" */
    h60Text: ReactNode;
    /** Detected variants: "percent-item" */
    className?: string;
    /** Detected variants: "percent-img" */
    div0ClassName?: string;
    /** Detected variants: "percent" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "percent" */
    h50ClassName?: string;
    /** Detected variants: "title" */
    h60ClassName?: string;
};

type HeaderSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-11.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
};

type HeaderSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeElevenHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeaderSectionPercentsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionSupport3sItem) => Partial<ComponentProps<"h5">>);
    divH50H5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionPercentsItem) => Partial<ComponentProps<"h5">>);
    divH60H6Props?: Partial<ComponentProps<"h6">> | ((item: HeaderSectionPercentsItem) => Partial<ComponentProps<"h6">>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0Div0DivDataWowDuration?: string;
    /** Default: "WE PROVIDE ADVANCED" */
    sectionDiv0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "SURGERY" */
    sectionDiv0Div0Div0Div0H10H1Text2?: ReactNode;
    /** Default: "SOLUTIONS" */
    sectionDiv0Div0Div0Div0H10H1Text3?: ReactNode;
    sectionDiv0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "banner-img" */
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-11.png" */
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "COSMETIC" */
    sectionDiv0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "#" */
    sectionDiv0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "Search Specialist" */
    sectionDiv0Div0Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "k+" */
    sectionDiv0Div0Div0Div2Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div2Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div2Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div2Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Successful Procedures" */
    sectionDiv0Div0Div0Div2Div0Div0Span0SpanText?: ReactNode;
    /** Default: "k+" */
    sectionDiv0Div0Div0Div2Div0Div1H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div2Div0Div1H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div2Div0Div1H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div2Div0Div1H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Certified Surgeons" */
    sectionDiv0Div0Div0Div2Div0Div1Span0SpanText?: ReactNode;
    /** Default: "k+" */
    sectionDiv0Div0Div0Div2Div0Div2H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div2Div0Div2H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div2Div0Div2H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div2Div0Div2H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Transformed Patients" */
    sectionDiv0Div0Div0Div2Div0Div2Span0SpanText?: ReactNode;
    /** Default: "" */
    sectionDiv0Div0Div0Div2Link0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionDiv0Div0Div0Div2Link0LinkHref?: string;
    sectionDiv0Div0Div0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "" */
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-eleven.jpg" */
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "1s" */
    sectionDiv0Div0Div1DivDataWowDuration?: string;
    /** Default: "Natural Beauty Through Expertise" */
    sectionDiv0Div0Div1Div0H40H4Text?: ReactNode;
    sectionDiv0Div0Div1Div0H40H4Visible?: boolean;
    sectionDiv0Div0Div1Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "Cosmetic surgery is a specialized practice focused on enhancing natural beauty through safe and advanced treatments." */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    /** Default: "“Our cosmetic surgery center enhances beauty with advanced treatments and expert care.”" */
    sectionDiv0Div0Div1Div2P0PText?: ReactNode;
    /** Default: "" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-eleven-2.png" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    sectionDiv0Div0Div1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-eleven-3.png" */
    sectionDiv0Div0Div1ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    sectionHeader0Div0Nav0Div0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    sectionHeader0Div0Nav0Div0Div0Link0LinkId?: string;
    sectionHeader0Div0Nav0Div0Div0Link0LinkVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home11" */
    sectionHeader0Div0Nav0Div0Div0Link1LinkHref?: string;
    sectionHeader0Div0Nav0Div0Div0Link1LinkVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-11.svg" */
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageSrc?: string;
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home11" */
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkHref?: string;
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-11.svg" */
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkId?: string;
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Contact Information" */
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Text?: ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Visible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Follow Us" */
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Text?: ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Visible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.login" */
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkHref?: string;
    /** Default: "Sign In" */
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkText?: ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.register" */
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkHref?: string;
    /** Default: "Sign Up" */
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkText?: ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkVisible?: boolean;
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionHeader0Div0Nav0Ul0Li0Link0LinkHref?: string;
    /** Default: "dark-mode-toggle" */
    sectionHeader0Div0Nav0Ul0Li0Link0LinkId?: string;
    /** Default: "#" */
    sectionHeader0Div0Nav0Ul0Li0Link1LinkHref?: string;
    /** Default: "light-mode-toggle" */
    sectionHeader0Div0Nav0Ul0Li0Link1LinkId?: string;
    /** Default: "search_popup" */
    sectionHeader0Div0Nav0Ul0Li1Link0LinkAriaControls?: string;
    /** Default: "#search_popup" */
    sectionHeader0Div0Nav0Ul0Li1Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    sectionHeader0Div0Nav0Ul0Li1Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    sectionHeader0Div0Nav0Ul0Li1Link0LinkHref?: string;
    sectionHeader0Div0Nav0Ul0Li1Link0LinkVisible?: boolean;
    sectionHeader0Div0Nav0Ul0Li1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Ul0Li1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.booking" */
    sectionHeader0Div0Nav0Ul0Li2Link0LinkHref?: string;
    sectionHeader0Div0Nav0Ul0Li2Link0LinkVisible?: boolean;
    sectionHeader0Div0Nav0Ul0Li2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Ul0Li2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Appointment" */
    sectionHeader0Div0Nav0Ul0Li2Link0Span0SpanText?: ReactNode;
    /** Default: "#support_item" */
    sectionHeader0Div0Nav0Ul0Li3Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    sectionHeader0Div0Nav0Ul0Li3Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    sectionHeader0Div0Nav0Ul0Li3Link0LinkHref?: string;
    sectionHeader0Div0Nav0Ul0Li3Link0LinkVisible?: boolean;
    sectionHeader0Div0Nav0Ul0Li3Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionHeader0Div0Nav0Ul0Li3Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "banner-img" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-eleven-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeaderSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    headerSectionSupport3s: HeaderSectionSupport3sItem[];
    headerSectionPercents: HeaderSectionPercentsItem[];
    headerSectionAvatarAvatarRoundeds: HeaderSectionAvatarAvatarRoundedsItem[];
    headerSectionUls: HeaderSectionUlsItem[];
    headerSectionSupport3sItemWrapper?: (item: HeaderSectionSupport3sItem, content: ReactNode) => ReactNode;
    headerSectionSupport3sRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionSupport3sH5Visible?: boolean;
    headerSectionSupport3sH5Renderer?: (item: HeaderSectionSupport3sItem, defaultNode: ReactNode) => ReactNode;
    headerSectionSupport3sH5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionSupport3sItem) => Partial<ComponentProps<"h5">>);
    headerSectionPercentsItemWrapper?: (item: HeaderSectionPercentsItem, content: ReactNode) => ReactNode;
    headerSectionPercentsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionPercentsImageVisible?: boolean;
    headerSectionPercentsImageRenderer?: (item: HeaderSectionPercentsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionPercentsH5Visible?: boolean;
    headerSectionPercentsH5Renderer?: (item: HeaderSectionPercentsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionPercentsH6Visible?: boolean;
    headerSectionPercentsH6Renderer?: (item: HeaderSectionPercentsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionPercentsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeaderSectionPercentsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    headerSectionPercentsH5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionPercentsItem) => Partial<ComponentProps<"h5">>);
    headerSectionPercentsH6Props?: Partial<ComponentProps<"h6">> | ((item: HeaderSectionPercentsItem) => Partial<ComponentProps<"h6">>);
    headerSectionAvatarAvatarRoundedsItemWrapper?: (item: HeaderSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    headerSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionAvatarAvatarRoundedsImageVisible?: boolean;
    headerSectionAvatarAvatarRoundedsImageRenderer?: (item: HeaderSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeaderSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    headerSectionUlsItemWrapper?: (item: HeaderSectionUlsItem, content: ReactNode) => ReactNode;
    headerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUlsLinkVisible?: boolean;
    headerSectionUlsLinkRenderer?: (item: HeaderSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeElevenHeaderSectionGenerated: FC<HomeElevenHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0H10H1Text = "WE PROVIDE ADVANCED",
    sectionDiv0Div0Div0Div0H10H1Text2 = "SURGERY",
    sectionDiv0Div0Div0Div0H10H1Text3 = "SOLUTIONS",
    sectionDiv0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageAlt = "banner-img",
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-11.png",
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0H10Span0SpanText = "COSMETIC",
    sectionDiv0Div0Div0Div1Link0LinkHref = "#",
    sectionDiv0Div0Div0Div1Link0LinkText = "Search Specialist",
    sectionDiv0Div0Div0Div1Link0LinkVisible,
    sectionDiv0Div0Div0Div1Link0LinkRenderer,
    sectionDiv0Div0Div0Div1Link0LinkProps,
    sectionDiv0Div0Div0Div2Div0Div0H20H2Text = "k+",
    sectionDiv0Div0Div0Div2Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div2Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div2Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div2Div0Div0Span0SpanText = "Successful Procedures",
    sectionDiv0Div0Div0Div2Div0Div1H20H2Text = "k+",
    sectionDiv0Div0Div0Div2Div0Div1H20H2Visible,
    sectionDiv0Div0Div0Div2Div0Div1H20H2Renderer,
    sectionDiv0Div0Div0Div2Div0Div1H20H2Props,
    sectionDiv0Div0Div0Div2Div0Div1Span0SpanText = "Certified Surgeons",
    sectionDiv0Div0Div0Div2Div0Div2H20H2Text = "k+",
    sectionDiv0Div0Div0Div2Div0Div2H20H2Visible,
    sectionDiv0Div0Div0Div2Div0Div2H20H2Renderer,
    sectionDiv0Div0Div0Div2Div0Div2H20H2Props,
    sectionDiv0Div0Div0Div2Div0Div2Span0SpanText = "Transformed Patients",
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageAlt = "",
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-eleven.jpg",
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div2Link0LinkDataFancybox = "",
    sectionDiv0Div0Div0Div2Link0LinkHref = "#",
    sectionDiv0Div0Div0Div2Link0LinkVisible,
    sectionDiv0Div0Div0Div2Link0LinkRenderer,
    sectionDiv0Div0Div0Div2Link0LinkProps,
    sectionDiv0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0H40H4Text = "Natural Beauty Through Expertise",
    sectionDiv0Div0Div1Div0H40H4Visible,
    sectionDiv0Div0Div1Div0H40H4Renderer,
    sectionDiv0Div0Div1Div0H40H4Props,
    sectionDiv0Div0Div1Div0P0PText = "Cosmetic surgery is a specialized practice focused on enhancing natural beauty through safe and advanced treatments.",
    sectionDiv0Div0Div1Div2P0PText = "“Our cosmetic surgery center enhances beauty with advanced treatments and expert care.”",
    sectionDiv0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt = "",
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-eleven-2.png",
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1ImageWithBasePath1ImageAlt = "",
    sectionDiv0Div0Div1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-eleven-3.png",
    sectionDiv0Div0Div1ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath1ImageProps,
    sectionHeader0Div0Nav0Div0Div0Link0LinkHref = "#",
    sectionHeader0Div0Nav0Div0Div0Link0LinkId = "mobile_btn",
    sectionHeader0Div0Nav0Div0Div0Link0LinkVisible,
    sectionHeader0Div0Nav0Div0Div0Link0LinkRenderer,
    sectionHeader0Div0Nav0Div0Div0Link0LinkProps,
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-11.svg",
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageVisible,
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageRenderer,
    sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageProps,
    sectionHeader0Div0Nav0Div0Div0Link1LinkHref = "all_routes.home11",
    sectionHeader0Div0Nav0Div0Div0Link1LinkVisible,
    sectionHeader0Div0Nav0Div0Div0Link1LinkRenderer,
    sectionHeader0Div0Nav0Div0Div0Link1LinkProps,
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-11.svg",
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageVisible,
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageProps,
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkHref = "all_routes.home11",
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkVisible,
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkRenderer,
    sectionHeader0Div0Nav0Div0Div1Div0Link0LinkProps,
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkHref = "#",
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkId = "menu_close",
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkVisible,
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkRenderer,
    sectionHeader0Div0Nav0Div0Div1Div0Link1LinkProps,
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Text = "Contact Information",
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Visible,
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Renderer,
    sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Props,
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Text = "Follow Us",
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Visible,
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Renderer,
    sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Props,
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkHref = "all_routes.login",
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkText = "Sign In",
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkVisible,
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkRenderer,
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkProps,
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkHref = "all_routes.register",
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkText = "Sign Up",
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkVisible,
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkRenderer,
    sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkProps,
    sectionHeader0Div0Nav0Ul0Li0Link0LinkHref = "#",
    sectionHeader0Div0Nav0Ul0Li0Link0LinkId = "dark-mode-toggle",
    sectionHeader0Div0Nav0Ul0Li0Link1LinkHref = "#",
    sectionHeader0Div0Nav0Ul0Li0Link1LinkId = "light-mode-toggle",
    sectionHeader0Div0Nav0Ul0Li1Link0LinkAriaControls = "search_popup",
    sectionHeader0Div0Nav0Ul0Li1Link0LinkDataBsTarget = "#search_popup",
    sectionHeader0Div0Nav0Ul0Li1Link0LinkDataBsToggle = "offcanvas",
    sectionHeader0Div0Nav0Ul0Li1Link0LinkHref = "#",
    sectionHeader0Div0Nav0Ul0Li1Link0LinkVisible,
    sectionHeader0Div0Nav0Ul0Li1Link0LinkRenderer,
    sectionHeader0Div0Nav0Ul0Li1Link0LinkProps,
    sectionHeader0Div0Nav0Ul0Li2Link0LinkHref = "all_routes.booking",
    sectionHeader0Div0Nav0Ul0Li2Link0LinkVisible,
    sectionHeader0Div0Nav0Ul0Li2Link0LinkRenderer,
    sectionHeader0Div0Nav0Ul0Li2Link0LinkProps,
    sectionHeader0Div0Nav0Ul0Li2Link0Span0SpanText = "Book Appointment",
    sectionHeader0Div0Nav0Ul0Li3Link0LinkDataBsTarget = "#support_item",
    sectionHeader0Div0Nav0Ul0Li3Link0LinkDataBsToggle = "offcanvas",
    sectionHeader0Div0Nav0Ul0Li3Link0LinkHref = "#",
    sectionHeader0Div0Nav0Ul0Li3Link0LinkVisible,
    sectionHeader0Div0Nav0Ul0Li3Link0LinkRenderer,
    sectionHeader0Div0Nav0Ul0Li3Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "banner-img",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-eleven-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv1H50H5Props,
    divH50H5Props,
    divH60H6Props,
    liLink0LinkProps,
    spanImageWithBasePath0ImageProps,
    headerSectionSupport3s,
    headerSectionPercents,
    headerSectionAvatarAvatarRoundeds,
    headerSectionUls,
    headerSectionSupport3sItemWrapper,
    headerSectionSupport3sRenderer,
    headerSectionSupport3sH5Visible,
    headerSectionSupport3sH5Renderer,
    headerSectionSupport3sH5Props,
    headerSectionPercentsItemWrapper,
    headerSectionPercentsRenderer,
    headerSectionPercentsImageVisible,
    headerSectionPercentsImageRenderer,
    headerSectionPercentsH5Visible,
    headerSectionPercentsH5Renderer,
    headerSectionPercentsH6Visible,
    headerSectionPercentsH6Renderer,
    headerSectionPercentsImageProps,
    headerSectionPercentsH5Props,
    headerSectionPercentsH6Props,
    headerSectionAvatarAvatarRoundedsItemWrapper,
    headerSectionAvatarAvatarRoundedsRenderer,
    headerSectionAvatarAvatarRoundedsImageVisible,
    headerSectionAvatarAvatarRoundedsImageRenderer,
    headerSectionAvatarAvatarRoundedsImageProps,
    headerSectionUlsItemWrapper,
    headerSectionUlsRenderer,
    headerSectionUlsLinkVisible,
    headerSectionUlsLinkRenderer,
    headerSectionUlsLinkProps,
}) => {
    return (
        <>
            <section className="hero-section-eleven">
                <header className={isScrolled ? "header header-eleven fixed" : "header header-eleven"}>
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-lg header-nav">
                            <div className="navbar-left-header">
                                <div className="navbar-header">
                                    {renderNode(sectionHeader0Div0Nav0Div0Div0Link0LinkVisible, sectionHeader0Div0Nav0Div0Div0Link0LinkRenderer, (
                                        <SmartLink id={sectionHeader0Div0Nav0Div0Div0Link0LinkId} href={sectionHeader0Div0Nav0Div0Div0Link0LinkHref} onClick={onMobileBtn} {...(sectionHeader0Div0Nav0Div0Div0Link0LinkProps ?? {})}>
                                            <i className="fa-solid fa-bars" />
                                        </SmartLink>
                                    ))}
                                    {renderNode(sectionHeader0Div0Nav0Div0Div0Link1LinkVisible, sectionHeader0Div0Nav0Div0Div0Link1LinkRenderer, (
                                        <SmartLink href={sectionHeader0Div0Nav0Div0Div0Link1LinkHref} className="navbar-brand logo" {...(sectionHeader0Div0Nav0Div0Div0Link1LinkProps ?? {})}>
                                            {renderNode(sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageVisible, sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageRenderer, (
                                                <SmartImage src={sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageAlt} {...(sectionHeader0Div0Nav0Div0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                            ))}
                                        </SmartLink>
                                    ))}
                                </div>
                                <div className="main-menu-wrapper">
                                    <div className="menu-header">
                                        {renderNode(sectionHeader0Div0Nav0Div0Div1Div0Link0LinkVisible, sectionHeader0Div0Nav0Div0Div1Div0Link0LinkRenderer, (
                                            <SmartLink href={sectionHeader0Div0Nav0Div0Div1Div0Link0LinkHref} className="menu-logo" {...(sectionHeader0Div0Nav0Div0Div1Div0Link0LinkProps ?? {})}>
                                                {renderNode(sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageVisible, sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                                    <SmartImage src={sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(sectionHeader0Div0Nav0Div0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        {renderNode(sectionHeader0Div0Nav0Div0Div1Div0Link1LinkVisible, sectionHeader0Div0Nav0Div0Div1Div0Link1LinkRenderer, (
                                            <SmartLink id={sectionHeader0Div0Nav0Div0Div1Div0Link1LinkId} className="menu-close" href={sectionHeader0Div0Nav0Div0Div1Div0Link1LinkHref} onClick={onMenuClose} {...(sectionHeader0Div0Nav0Div0Div1Div0Link1LinkProps ?? {})}>
                                                <i className="fas fa-times" />
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <HeaderNav menus={menus} />
                                    <div className="header-items">
                                        <div className="about-popup-item border-0 pb-0">
                                            {renderNode(sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Visible, sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Renderer, (
                                                <h3 className="title" {...(sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Props ?? {})}>{sectionHeader0Div0Nav0Div0Div1Div1Div0H30H3Text}</h3>
                                            ))}
                                            {renderCollectionNode(
                                                headerSectionSupport3s,
                                                (item: HeaderSectionSupport3sItem) => (
                                                    <div className={item.className} key={item.key}>
                                                        <div className={item.div0ClassName ?? "avatar avatar-lg bg-primary rounded-circle"}>
                                                            <i className={item.i0ClassName} />
                                                        </div>
                                                        <div>
                                                            <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                            {renderItemNode(headerSectionSupport3sH5Visible, headerSectionSupport3sH5Renderer, item, (
                                                                <h5 className={item.h50ClassName ?? "link"} {...(typeof headerSectionSupport3sH5Props === "function" ? headerSectionSupport3sH5Props(item) : (headerSectionSupport3sH5Props ?? {}))} {...(typeof divDiv1H50H5Props === "function" ? divDiv1H50H5Props(item) : (divDiv1H50H5Props ?? {}))}>{item.h50Text}</h5>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ),
                                                headerSectionSupport3sItemWrapper,
                                                headerSectionSupport3sRenderer
                                            )}
                                        </div>
                                        <div className="about-popup-item border-0 pb-0">
                                            {renderNode(sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Visible, sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Renderer, (
                                                <h3 className="title" {...(sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Props ?? {})}>{sectionHeader0Div0Nav0Div0Div1Div1Div1H30H3Text}</h3>
                                            ))}
                                            <ul className="d-flex align-items-center gap-2 social-iyem">
                                                {renderCollectionNode(
                                                    headerSectionUls,
                                                    (item: HeaderSectionUlsItem) => (
                                                        <li key={item.key}>
                                                            {renderItemNode(headerSectionUlsLinkVisible, headerSectionUlsLinkRenderer, item, (
                                                                <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} {...(typeof headerSectionUlsLinkProps === "function" ? headerSectionUlsLinkProps(item) : (headerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                                    <i className={item.className} />
                                                                </SmartLink>
                                                            ))}
                                                        </li>
                                                    ),
                                                    headerSectionUlsItemWrapper,
                                                    headerSectionUlsRenderer
                                                )}
                                            </ul>
                                        </div>
                                        <div className="header-items-button">
                                            {renderNode(sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkVisible, sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkRenderer, (
                                                <SmartLink href={sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkHref} className="btn btn-primary" {...(sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkProps ?? {})}>
                                                    <i className="isax isax-lock-1 me-2" />
                                                    {sectionHeader0Div0Nav0Div0Div1Div1Div2Link0LinkText}
                                                </SmartLink>
                                            ))}
                                            {renderNode(sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkVisible, sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkRenderer, (
                                                <SmartLink href={sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkHref} className="btn btn-dark" {...(sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkProps ?? {})}>
                                                    <i className="isax isax-user-tick4 me-2" />
                                                    {sectionHeader0Div0Nav0Div0Div1Div1Div2Link1LinkText}
                                                </SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ul className="nav header-navbar-rht">
                                <li className="header-theme">
                                    <DarkModeToggle mode="standard" />
                                </li>
                                <li>
                                    {renderNode(sectionHeader0Div0Nav0Ul0Li1Link0LinkVisible, sectionHeader0Div0Nav0Ul0Li1Link0LinkRenderer, (
                                        <SmartLink href={sectionHeader0Div0Nav0Ul0Li1Link0LinkHref} className="search-btn" tabIndex={-1} data-bs-toggle={sectionHeader0Div0Nav0Ul0Li1Link0LinkDataBsToggle} data-bs-target={sectionHeader0Div0Nav0Ul0Li1Link0LinkDataBsTarget} aria-controls={sectionHeader0Div0Nav0Ul0Li1Link0LinkAriaControls} {...(sectionHeader0Div0Nav0Ul0Li1Link0LinkProps ?? {})}>
                                            <i className="isax isax-search-normal-1" />
                                        </SmartLink>
                                    ))}
                                </li>
                                <li>
                                    {renderNode(sectionHeader0Div0Nav0Ul0Li2Link0LinkVisible, sectionHeader0Div0Nav0Ul0Li2Link0LinkRenderer, (
                                        <SmartLink href={sectionHeader0Div0Nav0Ul0Li2Link0LinkHref} className="btn btn-secondary" {...(sectionHeader0Div0Nav0Ul0Li2Link0LinkProps ?? {})}>
                                            <span className="text">{sectionHeader0Div0Nav0Ul0Li2Link0Span0SpanText}</span>
                                            {" "}
                                            <span className="icon">
                                                <i className="isax isax-arrow-right-3" />
                                            </span>
                                        </SmartLink>
                                    ))}
                                </li>
                                <li>
                                    {renderNode(sectionHeader0Div0Nav0Ul0Li3Link0LinkVisible, sectionHeader0Div0Nav0Ul0Li3Link0LinkRenderer, (
                                        <SmartLink href={sectionHeader0Div0Nav0Ul0Li3Link0LinkHref} className="details-btn" data-bs-toggle={sectionHeader0Div0Nav0Ul0Li3Link0LinkDataBsToggle} data-bs-target={sectionHeader0Div0Nav0Ul0Li3Link0LinkDataBsTarget} {...(sectionHeader0Div0Nav0Ul0Li3Link0LinkProps ?? {})}>
                                            <i className="isax isax-menu-14" />
                                        </SmartLink>
                                    ))}
                                </li>
                            </ul>
                        </nav>
                    </div>
                </header>
                <div className="container-fluid">
                    <div className="banner-section-eleven">
                        <div className="banner-left wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0DivDataWowDuration}>
                            <div className="section-header">
                                {renderNode(sectionDiv0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="section-title" {...(sectionDiv0Div0Div0Div0H10H1Props ?? {})}>
                                        {sectionDiv0Div0Div0Div0H10H1Text}
                                        <br />
                                        <span className="text-stroke">{sectionDiv0Div0Div0Div0H10Span0SpanText}</span>
                                        {sectionDiv0Div0Div0Div0H10H1Text2}
                                        <br />
                                        {sectionDiv0Div0Div0Div0H10H1Text3}
                                        {renderNode(sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0H10ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </h1>
                                ))}
                            </div>
                            <div className="banner-btn-eleven">
                                {renderNode(sectionDiv0Div0Div0Div1Link0LinkVisible, sectionDiv0Div0Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div1Link0LinkHref} className="btn btn-primary" {...(sectionDiv0Div0Div0Div1Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div0Div1Link0LinkText}
                                        {" "}
                                        <span>
                                            <i className="isax isax-arrow-right-3" />
                                        </span>
                                    </SmartLink>
                                ))}
                            </div>
                            <div className="banner-count-eleven">
                                {renderNode(sectionDiv0Div0Div0Div2Link0LinkVisible, sectionDiv0Div0Div0Div2Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div2Link0LinkHref} className="banner-video" data-fancybox={sectionDiv0Div0Div0Div2Link0LinkDataFancybox} {...(sectionDiv0Div0Div0Div2Link0LinkProps ?? {})}>
                                        {renderNode(sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div2Link0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                        <span className="vid-btn">
                                            {" "}
                                            <i className="isax isax-play5" />
                                            {" "}
                                        </span>
                                    </SmartLink>
                                ))}
                                <div className="banner-count-item">
                                    <div className="banner-count-number one">
                                        {renderNode(sectionDiv0Div0Div0Div2Div0Div0H20H2Visible, sectionDiv0Div0Div0Div2Div0Div0H20H2Renderer, (
                                            <h2 className="number" {...(sectionDiv0Div0Div0Div2Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div2Div0Div0H20H2Text}</h2>
                                        ))}
                                        <span>{sectionDiv0Div0Div0Div2Div0Div0Span0SpanText}</span>
                                    </div>
                                    <div className="banner-count-number two">
                                        {renderNode(sectionDiv0Div0Div0Div2Div0Div1H20H2Visible, sectionDiv0Div0Div0Div2Div0Div1H20H2Renderer, (
                                            <h2 className="number" {...(sectionDiv0Div0Div0Div2Div0Div1H20H2Props ?? {})}>{sectionDiv0Div0Div0Div2Div0Div1H20H2Text}</h2>
                                        ))}
                                        <span>{sectionDiv0Div0Div0Div2Div0Div1Span0SpanText}</span>
                                    </div>
                                    <div className="banner-count-number three">
                                        {renderNode(sectionDiv0Div0Div0Div2Div0Div2H20H2Visible, sectionDiv0Div0Div0Div2Div0Div2H20H2Renderer, (
                                            <h2 className="number" {...(sectionDiv0Div0Div0Div2Div0Div2H20H2Props ?? {})}>{sectionDiv0Div0Div0Div2Div0Div2H20H2Text}</h2>
                                        ))}
                                        <span>{sectionDiv0Div0Div0Div2Div0Div2Span0SpanText}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="banner-right wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1DivDataWowDuration}>
                            <div className="banner-content">
                                {renderNode(sectionDiv0Div0Div1Div0H40H4Visible, sectionDiv0Div0Div1Div0H40H4Renderer, (
                                    <h4 {...(sectionDiv0Div0Div1Div0H40H4Props ?? {})}>{sectionDiv0Div0Div1Div0H40H4Text}</h4>
                                ))}
                                <p>{sectionDiv0Div0Div1Div0P0PText}</p>
                            </div>
                            <div className="banner-percent">
                                {renderCollectionNode(
                                    headerSectionPercents,
                                    (item: HeaderSectionPercentsItem) => (
                                        <div className={item.className ?? "percent-item"} key={item.key}>
                                            {renderItemNode(headerSectionPercentsH5Visible, headerSectionPercentsH5Renderer, item, (
                                                <h5 className={item.h50ClassName ?? "percent"} {...(typeof headerSectionPercentsH5Props === "function" ? headerSectionPercentsH5Props(item) : (headerSectionPercentsH5Props ?? {}))} {...(typeof divH50H5Props === "function" ? divH50H5Props(item) : (divH50H5Props ?? {}))}>{item.h50Text}</h5>
                                            ))}
                                            <div className={item.div0ClassName ?? "percent-img"}>
                                                {renderItemNode(headerSectionPercentsImageVisible, headerSectionPercentsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "percent"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof headerSectionPercentsImageProps === "function" ? headerSectionPercentsImageProps(item) : (headerSectionPercentsImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            {renderItemNode(headerSectionPercentsH6Visible, headerSectionPercentsH6Renderer, item, (
                                                <h6 className={item.h60ClassName ?? "title"} {...(typeof headerSectionPercentsH6Props === "function" ? headerSectionPercentsH6Props(item) : (headerSectionPercentsH6Props ?? {}))} {...(typeof divH60H6Props === "function" ? divH60H6Props(item) : (divH60H6Props ?? {}))}>{item.h60Text}</h6>
                                            ))}
                                        </div>
                                    ),
                                    headerSectionPercentsItemWrapper,
                                    headerSectionPercentsRenderer
                                )}
                            </div>
                            <div className="banner-avatar">
                                <p>{sectionDiv0Div0Div1Div2P0PText}</p>
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        headerSectionAvatarAvatarRoundeds,
                                        (item: HeaderSectionAvatarAvatarRoundedsItem) => (
                                            <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                {renderItemNode(headerSectionAvatarAvatarRoundedsImageVisible, headerSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof headerSectionAvatarAvatarRoundedsImageProps === "function" ? headerSectionAvatarAvatarRoundedsImageProps(item) : (headerSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        headerSectionAvatarAvatarRoundedsItemWrapper,
                                        headerSectionAvatarAvatarRoundedsRenderer
                                    )}
                                </div>
                            </div>
                            {renderNode(sectionDiv0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid banner-eleven-2" {...(sectionDiv0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath1ImageAlt} className="img-fluid banner-eleven-3" {...(sectionDiv0Div0Div1ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
                {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid banner-eleven" {...(sectionImageWithBasePath0ImageProps ?? {})} />
                ))}
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeElevenHeaderSectionGenerated;
